import React, { PropTypes } from 'react';
import { Form, Input } from 'semantic-ui-react';

export const RadioOptionWithComment = ({
  title,
  name,
  value,
  valueOther,
  onChange,
  onChangeOther,
  width,
  readOnly,
}) => {
  const onCheckedChange = (evt, change) => {
    let value = undefined;
    if (change.value === 'true') {
      value = true;
    } else if (change.value === 'false') {
      value = false;
    }

    onChange(evt, { ...change, value });
  };

  return (
    <Form.Field width={width}>
      <label>{title}</label>
      <Form.Group inline style={{ marginBottom: '5px' }}>
        <Form.Radio
          label="Oui"
          name={name}
          value="true"
          checked={value === true}
          onChange={onCheckedChange}
          width={2}
          readOnly={readOnly}
        />
        <Form.Radio
          label="Non"
          name={name}
          value="false"
          checked={value === false}
          onChange={onCheckedChange}
          width={2}
          readOnly={readOnly}
        />
        <Form.Radio
          label="Je ne sais pas"
          name={name}
          value="undefined"
          checked={value !== true && value !== false}
          onChange={onCheckedChange}
          width={2}
          readOnly={readOnly}
        />
      </Form.Group>
      <Form.Group inline>
        <label style={{ fontWeight: 'normal' }}>Commentaire</label>
        <Form.Field width={10}>
          <Input
            value={valueOther || ''}
            onChange={onChangeOther}
            size="small"
            readOnly={readOnly}
          />
        </Form.Field>
      </Form.Group>
    </Form.Field>
  );
};

RadioOptionWithComment.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  valueOther: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onChangeOther: PropTypes.func.isRequired,
  width: PropTypes.string,
};

export default RadioOptionWithComment;



// WEBPACK FOOTER //
// ./src/modules/common/components/RadioOptionWithComment.js